import React, { useEffect, useState } from "react"
import axios from "axios"
import { API_URL } from "../xhr/xhr.constants"
import { useNavigate, useParams } from "react-router"
import { Box, TextField, Button, Typography, Alert } from "@mui/material"

export default function PasswordResetConfirm() {
  const params = useParams()
  const navigate = useNavigate()
  const [password, setPassword] = useState("")
  const [password2, setPassword2] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)
  const [validToken, setValidToken] = useState(true)

  const uid = params.uid
  const token = params.token

  useEffect(() => {
    if (!uid || !token) setValidToken(false)
    else setValidToken(true)
  }, [uid, token])

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)

    if (!validToken) {
      setError("Ongeldige of ontbrekende reset link.")
      return
    }

    if (password.length < 8) {
      setError("Wachtwoord moet minimaal 8 tekens bevatten.")
      return
    }

    if (password !== password2) {
      setError("Wachtwoorden komen niet overeen.")
      return
    }

    setSubmitting(true)
    try {
      await axios.post(`${API_URL}/dj-rest-auth/password/reset/confirm/`, {
        new_password1: password,
        new_password2: password2,
        uid,
        token,
      })
      // On success, navigate to login
      navigate("/login")
    } catch (error: any) {
      parseError(error.response?.data || error.message || "Er is een fout opgetreden.")
    } finally {
      setSubmitting(false)
    }
  }

  function parseError(error: any) {
    try {
      const errors = Object.values(error).flat()
      setError(errors.join(" "))
    } catch (e) {
      setError("Er is een fout opgetreden. Probeer een ander wachtwoord en verzend opnieuw.")
    }

  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Typography component="h1" variant="h5">
          Reset wachtwoord
        </Typography>
      </div>

      {!validToken && (
        <Alert severity="error" sx={{ mt: 2 }}>
          Deze link is ongeldig of verlopen. Vraag een nieuwe reset link aan.
        </Alert>
      )}

      <Box sx={{ mt: 1 }}>
        <form onSubmit={onSubmit}>


          <TextField
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            label="Nieuw wachtwoord"
            type="password"
            fullWidth
            margin="normal"
            required
            disabled={!validToken}
          />

          <TextField
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            label="Bevestig nieuw wachtwoord"
            type="password"
            fullWidth
            margin="normal"
            required
            disabled={!validToken}
          />
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Box sx={{ mt: 2 }}>
            <Button type="submit" fullWidth variant="contained" disabled={submitting || !validToken}>
              {submitting ? "Bezig..." : "Reset"}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  )
}
